import { render, staticRenderFns } from "./Passengers.vue?vue&type=template&id=6205d052&"
import script from "./Passengers.vue?vue&type=script&lang=js&"
export * from "./Passengers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports